import hashUtils from 'app-lib/hashUtils'
import { links } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { ButtonClipboard, Icon } from 'ui-framework'
import MigrateTokensVM from './MigrateTokensVM'

export function OokiMigrationInfo({ vm }: { vm: MigrateTokensVM }) {
  return (
    <div className="panel--simple md-padded-2">
      <h3 className="title-section panel__header">Instructions</h3>
      <div className="txt-explanation">
        <p>
          <ExternalLink className="link--discreet" href={links.articles.ookiMigration}>
            Read this article
          </ExternalLink>{' '}
          for detailed information.
        </p>

        <h4 className="h4 margin-0">OOKI token</h4>
        <ul className="list-none margin-bottom-2">
          {vm.ookiInfo.map((info) => (
            <li key={info.address}>
              <Icon
                name={info.chainIcon.name}
                color={info.chainIcon.color}
                bgColor="var(--color-bg-alternative)"
                bgCircle
                bgPadding={3}
                size={28}
              />
              <ExternalLink
                className="link--discreet margin-h-1ch"
                href={info.ookiExplorerLink}
                title={info.address}>
                {hashUtils.shortHash(info.address, 8, 8)}
              </ExternalLink>
              <ButtonClipboard text={info.address} top={-5} />
            </li>
          ))}
        </ul>

        <h4 className="h4 margin-0">Converter Contract</h4>
        <ul className="list-none">
          {vm.ookiInfo.map((info) => (
            <li key={info.converterAddress}>
              <Icon
                name={info.chainIcon.name}
                color={info.chainIcon.color}
                bgColor="var(--color-bg-alternative)"
                bgCircle
                bgPadding={3}
                size={28}
              />
              <ExternalLink
                className="link--discreet margin-left-1ch"
                href={info.converterExplorerLink}
                title={info.converterAddress}>
                {hashUtils.shortHash(info.converterAddress, 8, 8)}
              </ExternalLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default observer(OokiMigrationInfo)
